import React, { ReactElement } from "react";

function Button({
  onClick,
  buttonText,
  isDisabled,
  widthFull,
  defaultColor,
  paddingX,
  paddingY,
  classNames,
  style,
  isLoading
}: {
  onClick?: any;
  buttonText: any;
  isDisabled?: any;
  widthFull?: boolean;
  defaultColor?: any;
  paddingX?: any;
  paddingY?: any;
  classNames?: any;
  style?: any;
  isLoading?: boolean;
}): ReactElement {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled || isLoading}
      style={style}
      className={
        isDisabled || isLoading
          ? `${widthFull && "w-full"} ${paddingX ?? "px-8"}
             text-xs sm:${paddingX} sm:text-sm md:text-sm bg-transparent focus:outline-none border border-gray-400 text-gray-400 font-semibold ${
              paddingY ?? `py-2`
            } rounded-lg ${classNames}`
          : `${widthFull && "w-full"} ${paddingX ?? "px-8"}
             text-xs sm:${paddingX} sm:text-sm md:text-sm ${defaultColor} hover:shadow-custom-btn hover:text-btn-text-hover focus:outline-none text-white font-semibold ${
              paddingY ?? `py-2`
            } rounded-lg ${classNames}`
      }
    >
      {buttonText}
    </button>
  );
}

Button.defaultProps = {
  isDisabled: false,
  onClick: () => {},
  defaultColor: "bg-primary",
  widthFull: false,
  paddingX: "px-12",
};

export default Button;
